module.exports = __webpack_public_path__ + "static/media/brightcove-logo.44a942b7.png";